import { enUS, de, pt, ptBR, es, fr, nl, it, zhCN, zhTW, ar } from 'date-fns/locale'

// Keys are the app locale codes (Locales::AVAILABLE / i18n.js), so consumers
// can index this map with $i18n.locale directly.
export default {
  en: enUS, de, pt, 'pt-BR': ptBR, es, fr, nl, it, 'zh-CN': zhCN, 'zh-TW': zhTW, ar
};
